// extracted by mini-css-extract-plugin
export default {"header":"kGcR0","header__visible":"EM5u7"};